/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Coinvestmenttotal2Inputs */

const en_coinvestments_insights_col_coinvestmenttotal2 = /** @type {(inputs: Coinvestments_Insights_Col_Coinvestmenttotal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-investment total`)
};

/**
* | output |
* | --- |
* | "Co-investment total" |
*
* @param {Coinvestments_Insights_Col_Coinvestmenttotal2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_coinvestmenttotal2 = /** @type {((inputs?: Coinvestments_Insights_Col_Coinvestmenttotal2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Coinvestmenttotal2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_coinvestmenttotal2(inputs)
});
export { coinvestments_insights_col_coinvestmenttotal2 as "coInvestments_insights_col_coinvestmentTotal" }